import { encrypt } from '@/common/securityUtils';

export const agentTypeMap: Record<string, string> = {
  affiliate: '6',
  customer: '3',
  club: '4',
};

export const encryptedAgentTypeMap: Record<string, string> = Object.fromEntries(
  Object.entries(agentTypeMap).map(([type, encryptedValue]) => [type, encrypt(encryptedValue)]),
);
